import { ChevronLeft, ChevronRight } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePreviewContext } from '../contexts/Preview';
import { useUserContext } from '../contexts/user';

const PreviewQuiz = () => {
    const navigate = useNavigate();

    const { previewQuestions } = usePreviewContext();
    const { appLanguage } = useUserContext();   

    const [questions, setQuestions] = useState(previewQuestions);
    const [questionIndex, setQuestionIndex] = useState(0);

    useEffect(() => {
        if (previewQuestions.length) {
            const appQuestions = questions.map(q => ({
                ...q,
                answers: [...q.answers],
            }));

            const newQuestions = [];

            while (newQuestions.length < questions.length && appQuestions.length > 0) {
                const randomIndex = Math.floor(Math.random() * appQuestions.length);
                const selectedQuestion = appQuestions.splice(randomIndex, 1)[0];

                const shuffledAnswers = [...selectedQuestion.answers].sort(() => Math.random() - 0.5);

                const newAnswers = shuffledAnswers.slice(0, 4);

                newQuestions.push({
                    question: selectedQuestion.question,
                    answers: newAnswers,
                    correctAnswer: selectedQuestion.correctAnswer,
                });
            }

            setQuestions(newQuestions);
        }
    }, []);

    return (
        <div className="preview_quiz_page">
            <header>
                <ChevronLeft onClick={() => navigate("/create")} />
                <p>{appLanguage === "ar" ? "معاينة الاختبار" : "Preview Quiz"}</p>
            </header>
            <div className="quiz_content">
                <div className="content">
                    <div className="question">{previewQuestions.length ? questions[questionIndex].question : appLanguage === "ar" ? "لا يوجد سؤال" : "No question found."}</div>
                    <div className="answers">
                        <button id="answer" className={previewQuestions.length && questions[questionIndex].answers[0] === questions[questionIndex].correctAnswer ? "active" : ""}>{previewQuestions.length ? questions[questionIndex].answers[0] : appLanguage === "ar" ? "لا يوجد إجابة" : "No answer found."}</button>
                        <button id="answer" className={previewQuestions.length && questions[questionIndex].answers[1] === questions[questionIndex].correctAnswer ? "active" : ""}>{previewQuestions.length ? questions[questionIndex].answers[1] : appLanguage === "ar" ? "لا يوجد إجابة" : "No answer found."}</button>
                        <button id="answer" className={previewQuestions.length && questions[questionIndex].answers[2] === questions[questionIndex].correctAnswer ? "active" : ""}>{previewQuestions.length ? questions[questionIndex].answers[2] : appLanguage === "ar" ? "لا يوجد إجابة" : "No answer found."}</button>
                        <button id="answer" className={previewQuestions.length && questions[questionIndex].answers[3] === questions[questionIndex].correctAnswer ? "active" : ""}>{previewQuestions.length ? questions[questionIndex].answers[3] : appLanguage === "ar" ? "لا يوجد إجابة" : "No answer found."}</button>
                    </div>
                </div>
            </div>
            <div className="controls">
                <button onClick={() => { previewQuestions.length && questionIndex > 0 && setQuestionIndex(questionIndex - 1) }}><ChevronLeft /> {appLanguage === "ar" ? "السابق" : "Prev"}</button>
                <button onClick={() => { previewQuestions.length && questionIndex < questions.length - 1 && setQuestionIndex(questionIndex + 1) }}>{appLanguage === "ar" ? "التالي" : "Next"} <ChevronRight /></button>
            </div>
        </div>
    )
}

export default PreviewQuiz